import React from 'react'
import { useSelector } from 'react-redux';
import { logOut } from '../Services/UserAuth/UserAuthenticate';

// this hook fetches logged in teacher's profile information from redux stoor
export default function useTeacherProfile() {
    
    const teacherProfileInformation = useSelector((state: any) => state.teacher.teacherSchool);
    // console.log("Teacher profile: ", teacherProfileInformation);
    // if(!teacherProfileInformation?.school?.name) { 
    //     let confirmLogout: boolean = window.confirm("Could not fetch data. Try logging out?");
    //     confirmLogout && logOut();
    // }
    return teacherProfileInformation;

}
